'use client'

import { motion, useInView } from 'motion/react'
import React, {useRef, useState} from 'react'

import newsBgPic from "@assets/images/news-bg.png";
import starPurplePic from "@assets/images/star-purple.png";
import tabletPic from "@assets/images/tablet.jpg";
import blogContentPic from "@assets/images/blog-content-pic.jpg";
import blogAvatarPic from "@assets/images/blog-avatar.png";
import arrowSmallPic from "@assets/images/arrow-small.png";
import axios from "axios";
import { toast } from 'react-toastify';
import { Link } from "react-router-dom";

export default function BlogDetail() {

  // const gotoPolarisInvest = ()=>{
  //   window.open('https://invest.polarisagi.com/', '_blank');
  // }

  const startStyle = {opacity: 0}
  const endStyle = {
    opacity: 1,
    ease: 'easeInOut',
  }
  const animationTransition = {
    duration: 2
  }

  const ref12 = useRef(null);
  const isRef12InView = useInView(ref12, {once: true})
  const ref13 = useRef(null);
  const isRef13InView = useInView(ref13, {once: true})
  const ref14 = useRef(null);
  const isRef14InView = useInView(ref14, {once: true})
  // 内容区
  const ref15 = useRef(null);
  const isRef15InView = useInView(ref15, {once: true})

  const [isSubscribing, setIsSubscribing] = useState(false);
  const [isBlur, setIsBlur] = React.useState(true);
  console.log('isSubscribing:', isSubscribing);
  console.log('isBlur:', isBlur);

  const submitForm = ()=>{
    setIsBlur(false)
    const form = document.getElementById('emailForm1') as HTMLFormElement
    if (!form.checkValidity()) {
      form.reportValidity();
      setTimeout(() => {
        setIsBlur(true)
      }, 100)
    } else {
      subscribe()
    }
  }
  console.log('submitForm:', submitForm);
  const subscribe = async ()=>{
    const emailInput = document.getElementById('emailInput1') as HTMLInputElement;
    const email = emailInput.value.trim();
    setIsSubscribing(true)
    const response = await axios.post(`${import.meta.env.VITE_APP_API_BASE_URL}/polaris-api/subscribe?email=${encodeURIComponent(email)}`);
    setIsSubscribing(false)

    if (response.data) {
      const { result } = response.data;
      if(result) {
        toast.success('Subscribe successfully.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        emailInput.value=''
      }
    }
  }

  return (
      <div className="mt-[66px] mx-10">
        <motion.section
          ref={ref12}
          initial={startStyle}
          animate={isRef12InView ? endStyle : {}}
          transition={animationTransition}
          className="w-[1280px] h-[452px] pl-0 pr-10 pt-20 pb-10 inline-flex flex-col justify-start items-start gap-2.5"
        >
          <div
            className="w-[1360px] h-[653px] absolute top-0 -left-0 -z-10 bg-gradient-to-b from-[#6E66E1] via-[#8B7CF4]/80 to-[#B2D2EA]/0"
          />
          <div className="">
            <div className="inline-flex flex-col justify-start items-start gap-4">
              <div className="inline-flex justify-start items-center gap-4">
                <div className="justify-start text-white text-base font-medium font-['Figtree']">Insights / Events</div>
                <div className="w-60 h-9" />
              </div>
              <div className="w-[945px] justify-start text-white text-7xl font-medium font-['Figtree'] leading-[83.60px]">The Basics about Cryptocurrency</div>
              <div className="inline-flex justify-start items-center gap-6">
                <div className="w-14 h-14 relative rounded-full overflow-hidden">
                  <img className="w-14 h-14 left-0 top-0 absolute" src={blogAvatarPic} />
                </div>
                <div className="inline-flex flex-col justify-start items-start gap-2">
                  <div className="justify-center text-white text-base font-bold font-['DM_Sans'] uppercase leading-none tracking-wide">Team polaris</div>
                  <div className="justify-center text-white text-base font-normal font-['DM_Sans'] uppercase leading-none tracking-wide">August 2, 2021</div>
                </div>
              </div>
              <div className="justify-center text-white text-lg font-normal font-['Figtree'] leading-loose">Lorem ipsum dolor sit ametero irseo, consectetur adipiscing elit. Scelerisque viverra donec diammeo.</div>
            </div>
          </div>
        </motion.section>

        <motion.section
          ref={ref13}
          initial={startStyle}
          animate={isRef13InView?endStyle:{}}
          transition={animationTransition}
          className="mb-20 flex flex-row justify-center rounded-[10px]"
          style={{backgroundImage:`url(${tabletPic})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat'}}
        >
          <div className="mx-auto -my-2">
            <div className="w-[1280px] h-[680px] px-10 py-16 bg-gradient-to-b via-[#000000]/30 from-black/0 to-[#6E66E1] rounded-[10px] inline-flex flex-col justify-end items-start gap-2.5">
            </div>
          </div>
        </motion.section>

        {/* 内容区 */}
        <motion.section
          ref={ref15}
          initial={startStyle}
          animate={isRef15InView?endStyle:{}}
          transition={animationTransition}
          className="my-20 flex flex-row justify-center rounded-[10px] relative"
        >
          <div className="mx-auto -my-2 w-[783px]">
            {/* 大标题 */}
            <div className="w-full justify-center text-[#414141] text-[39px] font-bold font-['Figtree'] leading-[55.02px]">Learn what you need to know before you invest in a virtual currency</div>
            {/* 中标题 */}
            <div className="self-stretch justify-center text-[#414141] text-[27px] font-bold font-['Figtree'] leading-8 mt-10 mb-2">Learn what you need to know before you invest in a virtual currency</div>
            {/* 正文 */}
            <div className="w-full justify-center text-[#414141] text-lg font-normal font-['Figtree'] leading-loose mt-4">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</div>
            <div className="w-full justify-center text-[#414141] text-lg font-normal font-['Figtree'] leading-loose mt-4">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
            {/* 图像 */}
            <img className="self-stretch w-full rounded-xl mt-10" src={blogContentPic} />
            {/* 中标题 */}
            <div className="self-stretch justify-center text-[#414141] text-[27px] font-bold font-['Figtree'] leading-8 mt-10 mb-2">Learn what you need to know before you invest in a virtual currency</div>
            {/* 正文 */}
            <div className="w-full justify-center text-[#414141] text-lg font-normal font-['Figtree'] leading-loose mt-4">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</div>
            <div className="w-full justify-center text-[#414141] text-lg font-normal font-['Figtree'] leading-loose mt-4">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
            {/* 引用 */}
            <div className="self-stretch px-16 py-20 bg-[#E8E8E8] rounded-xl inline-flex justify-center items-center gap-1 overflow-hidden mt-10">
              <div className="w-[613px] justify-center text-[#3C3C3C] text-xl font-normal font-['Figtree'] leading-9">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,</div>
            </div>
            {/* 中标题 */}
            <div className="self-stretch justify-center text-[#414141] text-[27px] font-bold font-['Figtree'] leading-8 mt-10 mb-2">Learn what you need to know before you invest in a virtual currency</div>
            {/* 正文 */}
            <div className="w-full justify-center text-[#414141] text-lg font-normal font-['Figtree'] leading-loose mt-4">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</div>
            <div className="w-full justify-center text-[#414141] text-lg font-normal font-['Figtree'] leading-loose mt-4">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
          </div>

          <div className="absolute top-0 right-0 w-64 p-5 bg-stone-50 rounded-xl outline outline-1 outline-offset-[-1px] inline-flex flex-col justify-center items-center gap-5">
              <div className="w-8 h-9" >
                <img
                  src={starPurplePic}
                  alt="Star"
                  className="object-cover"
                />
              </div>
              <div className="self-stretch text-center justify-start text-[#404040] text-3xl font-medium font-['Figtree']">Explore Polaris <br/>Invest Insights</div>
              <div className="self-stretch h-24 flex flex-col justify-center items-center gap-2.5">
                  <form id="emailForm1" className="self-stretch flex-1 flex flex-col justify-center items-center gap-2.5">
                      <input
                        id="emailInput1"
                        type="email"
                        placeholder="Email"
                        className={`self-stretch h-10 px-4 text-[14px] text-[#99ABB6] rounded-full bg-white border border-gray-200 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none ${isSubscribing?'cursor-not-allowed':''}`}
                        required
                        disabled={isSubscribing}
                        onKeyDown={(e) => {
                          setIsBlur(false);
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            const input = e.target as HTMLInputElement;
                            input.setCustomValidity('');
                            if (!input.checkValidity()) {
                              input.setCustomValidity('');
                            }
                            input.reportValidity();
                          } else {
                            const input = e.target as HTMLInputElement;
                            // 将验证信息设置为多个空格，可让验证信息不显示
                            input.setCustomValidity('  ');
                          }
                        }}
                        onBlur={(e)=>{
                          const input = e.target as HTMLInputElement;
                          if(!isBlur){
                            setIsBlur(true);
                            if (!input.checkValidity()) {
                              input.setCustomValidity('');
                            }
                          }
                        }}
                      />
                  </form>
                  <button disabled={isSubscribing} onClick={submitForm} type="submit" className="self-stretch h-10 px-6 py-4 bg-[#6E66E1] rounded-[100px] inline-flex justify-center items-center cursor-pointer hover:bg-[#5c4fd6] transition-colors">
                      <div className="justify-start text-white text-sm font-bold font-['Figtree']">Subscribe</div>
                      <div className="w-3 h-3 origin-center rotate-0 ml-2" >
                        <img
                          src={arrowSmallPic}
                          alt="Arrow"
                          className="object-cover"
                        />
                      </div>
                  </button>
              </div>
              <div className="self-stretch inline-flex justify-center items-center gap-3.5">
                  <div className="flex-1 justify-start">
                    <p className="text-[#676767] text-xs font-normal font-['Inter'] leading-[1.1]">We're committed to your privacy. POLARIS uses the information you provide to us to contact you about our relevant content, products, and services. You may unsubscribe from these communications at any time. For more information, check out our</p>
                    <p className="text-[#676767] text-xs font-normal font-['Inter'] underline leading-[1.1]"><Link to={`/privacy-policy`} target={`_blank`}>Privacy Policy</Link></p>
                    <p className="text-[#676767] text-xs font-normal font-['Inter'] leading-[1.1]">.</p>
                  </div>
              </div>
          </div>
        </motion.section>

        <motion.section ref={ref14} initial={startStyle} animate={isRef14InView?endStyle:{}} transition={animationTransition} className="pb-14 bg-white">
          <div className="mx-auto">
            <div className="w-full inline-flex justify-start items-center gap-14">
              <div className="flex-1 justify-start text-[#414141] text-7xl font-medium font-['Figtree']">Related Insights</div>
              <div className="bg-gray-100 flex item-center rounded-full text-gray-700 px-6 py-2 font-medium hover:bg-[#6E66E1] hover:text-white transition-all duration-300 ease-in-out group cursor-pointer">
                <a className="text-[#12121280] text-sm font-medium inline-flex items-center group-hover:text-white transition-colors duration-300">
                  View All <svg className="w-4 h-4 ml-2 text-[#12121280] transform transition-all duration-300 ease-in-out group-hover:text-white group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                </svg>
                </a>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-10">
              <div className="w-full bg-white overflow-hidden flex flex-col">
                <div className="relative h-[233px]">
                  <img
                    src={newsBgPic}
                    alt=""
                    style={{position:"absolute", top: 0, left: 0, minWidth: '100%', minHeight: '100%', objectFit: 'cover', objectPosition: 'center'}}
                  />
                  <div className="w-full h-full p-2.5 relative rounded-xl inline-flex justify-start items-start gap-2.5">
                    <div className="left-[12px] bottom-[0px] absolute inline-flex flex-col justify-start items-start gap-[5px]">
                      <div className="flex flex-col justify-start items-start gap-[0px]">
                        <div className="w-32 justify-start text-white text-2xl font-normal font-['Instrument_Serif'] capitalize leading-normal">HaoJun Jia</div>
                        <div className="justify-start text-white text-sm font-normal font-['Figtree']">Founder, Deep Principle</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-6 text-left flex flex-col flex-1">
                  <h3 className="self-stretch justify-start text-xl font-semibold text-[#414141] mb-10" style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    AI Investment Paradigm: What Are the Traits of the Next Generation of Great AI Companies?
                  </h3>
                  <div className="flex item-center font-medium mt-auto">
                    <a href="#" className="text-[#6E66E1] text-sm font-bold inline-flex items-center group hover:text-[#8586FF] transition-all duration-300">
                      Read More <svg className="w-4 h-4 ml-2 text-[#6E66E1] transform transition-all duration-300 ease-in-out group-hover:text-[#8586FF] group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                    </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className="w-full bg-white overflow-hidden flex flex-col">
                <div className="relative h-[233px]">
                  <img
                    src={newsBgPic}
                    alt=""
                    style={{position:"absolute", top: 0, left: 0, minWidth: '100%', minHeight: '100%', objectFit: 'cover', objectPosition: 'center'}}
                  />
                  <div className="w-full h-full p-2.5 relative rounded-xl inline-flex justify-start items-start gap-2.5">
                    <div className="left-[12px] bottom-[0px] absolute inline-flex flex-col justify-start items-start gap-[5px]">
                      <div className="flex flex-col justify-start items-start gap-[0px]">
                        <div className="w-32 justify-start text-white text-2xl font-normal font-['Instrument_Serif'] capitalize leading-normal">Zhijin Xia</div>
                        <div className="justify-start text-white text-sm font-normal font-['Figtree']">Managing Partner, Vertex Ventures</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-6 text-left flex flex-col flex-1">
                  <h3 className="self-stretch justify-start text-xl font-semibold text-[#414141] mb-10" style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    China’s Opportunity in AI for Science
                  </h3>
                  <div className="flex item-center font-medium mt-auto">
                    <a href="#" className="text-[#6E66E1] text-sm font-bold inline-flex items-center group hover:text-[#8586FF] transition-all duration-300 ease-in-out">
                      Read More <svg className="w-4 h-4 ml-2 text-[#6E66E1] transform transition-all duration-300 ease-in-out group-hover:text-[#8586FF] group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                    </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className="w-full bg-white overflow-hidden flex flex-col">
                <div className="relative h-[233px]">
                  <img
                    src={newsBgPic}
                    alt=""
                    style={{position:"absolute", top: 0, left: 0, minWidth: '100%', minHeight: '100%', objectFit: 'cover', objectPosition: 'center'}}
                  />
                  <div className="w-full h-full p-2.5 relative rounded-xl inline-flex justify-start items-start gap-2.5">
                    <div className="left-[12px] bottom-[0px] absolute inline-flex flex-col justify-start items-start gap-[5px]">
                      <div className="flex flex-col justify-start items-start gap-[0px]">
                        <div className="w-32 justify-start text-white text-2xl font-normal font-['Instrument_Serif'] capitalize leading-normal">Grant Hosking</div>
                        <div className="justify-start text-white text-sm font-normal font-['Figtree']">Managing Partner, Align Ventures; Figure AI Board Member</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-6 text-left flex flex-col flex-1">
                  <h3 className="self-stretch justify-start text-xl font-semibold text-[#414141] mb-10" style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    Humanoid Robots Will Ultimately Become a Trillion-Dollar Industry; Brett May Become the Next Musk
                  </h3>
                  <div className="flex item-center font-medium mt-auto">
                    <a href="#" className="text-[#6E66E1] text-sm font-bold inline-flex items-center group hover:text-[#8586FF] transition-all duration-300 ease-in-out">
                      Read More <svg className="w-4 h-4 ml-2 text-[#6E66E1] transform transition-all duration-300 ease-in-out group-hover:text-[#8586FF] group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                    </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.section>
      </div>
  );
}
